import { Directive, Input, ElementRef, HostListener } from "@angular/core";


@Directive({
    selector: '[appHoverReplaceText]',
    standalone: false
})

export class HoverReplaceTextDirective {

    @Input() new: string;
    @Input() original: string;

    constructor(private el: ElementRef) { }

    @HostListener('mouseenter') onMouseEnter() {
        this.changeText(this.new);
    }

    @HostListener('mouseleave') onMouseLeave() {
        this.changeText(this.original);
    }

    private changeText(text: string) {
        this.el.nativeElement.innerText = text;
    }
}
